<div class="infobox infobox-barometer" *ngIf="barometer; else infobox">
  <div class="align-barometer">
    <lib-barometer
      [barometerWidth]="200"
      [rangeLabels]="['summary.barometer.weak' | translate, 'summary.barometer.strong' | translate]"
      [arcSetting]="locale"
    ></lib-barometer>
  </div>
  <div class="align-content">
    <p class="title" *ngIf="title">{{ title }}</p>
    <p class="content">{{ content }}</p>
  </div>
</div>

<ng-template #infobox>
  <div class="infobox" *ngIf="!isSummary; else infoboxSummary">
    <p *ngIf="title" class="title">{{ title }}</p>
    <p class="content">{{ content }}</p>
  </div>
</ng-template>

<ng-template #infoboxSummary>
  <div class="infobox infobox-summary">
    <div class="info-icon"></div>
    <p class="content content-summary">{{ content }}</p>
  </div>
</ng-template>
